import { combineEpics, Epic } from 'redux-observable';
import { loadStoredTokenEpic } from "../usecases/loadStoredToken/epic";
import { sendLoginConfirmationCodeEpic } from "../usecases/confirmation/epic";

export const authenticationRootEpic: Epic = combineEpics(
    loadStoredTokenEpic,
    sendLoginConfirmationCodeEpic
)
